<template>
  <div>
    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th></th>
          <th>aktivní</th>
          <th>uživatelské jméno</th>
          <th>jméno</th>
          <th>příjmení</th>
          <th>přiřazen do skupin</th>
        </tr>
      </thead>
      <tbody>
        <UserRow v-for="u in users" :key="u.id" :user="u"></UserRow>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'
import UserRow from './row'

export default {
    name: 'UsersTable',
    components: {
        UserRow,
    },
    computed: {
        users() {
            return _.sortBy(this.$store.getters.users, ['username'])
        },
    },
    methods: {
        async save() {
            try {
                await Promise.all(this.users.map(u => this.$store.dispatch('updateUser', u)))
                this.flash('Nastavení se uložilo, aplikace se nyní restartuje.', 'warning', {
                    timeout: 5000,
                })
                window.location.reload()
            } catch (e) {
                this.flash(`Při vykonávání akce nastala chyba ${e}`, 'error', {
                    timeout: 3000,
                })
            }
        },
    },
}
</script>
